export interface AdminErrors {
    [action: string]: Error;
}

export type AdminState = {
    error?: AdminErrors;
};
